module.exports = __webpack_public_path__ + "static/media/space.abeecc0c.gif";